"use strict";
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        Globalize.addCultureInfo("en", {
            messages: {
                Tracing_PaneTitle: "Tracing",
                Tracing_Start: "Trace",
            },
        });
        var _tracing;
        (function (_tracing) {
            _tracing.style = "task-recorder-button";
            _tracing.started = $dyn.observable(false);
            _tracing.paneIsOpen = $dyn.observable(false);
            function open() {
                if (!_tracing.pane) {
                    _tracing.pane = {
                        name: "TracingPane",
                        role: "Dialog",
                        templateId: "TracingPane",
                    };
                    $dyn.shell.createForm(_tracing.pane);
                    var context_1 = $dyn.context(_tracing.pane.targetElement);
                    context_1.DisplayTarget = $dyn.forms.DisplayTarget.AsidePane;
                }
                $dyn.shell.open({ form: $dyn.context(_tracing.pane.targetElement) });
                _tracing.paneIsOpen(true);
            }
            _tracing.open = open;
        })(_tracing = ax._tracing || (ax._tracing = {}));
        // tslint:disable-next-line: class-name
        var _tracingPane = /** @class */ (function () {
            function _tracingPane() {
            }
            _tracingPane.prototype.RequestClose = function () {
                $dyn.ax._tracing.paneIsOpen(false);
            };
            return _tracingPane;
        }());
        ax._tracingPane = _tracingPane;
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Tracing.js.map
